'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function AlertBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="flex items-center justify-between px-4 py-3 rounded-lg animate-fade-in"
      style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.3)' }}>
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ background: 'rgba(245,158,11,0.15)' }}>
          <Icon name="ExclamationTriangleIcon" size={16} className="text-color-amber" />
        </div>
        <div>
          <span className="text-sm font-semibold text-color-amber">PAYE Submission Deadline Approaching</span>
          <span className="text-sm text-muted-foreground ml-2">
            RTI Full Payment Submission due in <strong className="text-card-foreground">12 days</strong> — Tax Month 3 (Jun 2026)
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button className="px-3 py-1 rounded-md text-xs font-semibold transition-all active:scale-95"
          style={{ background: 'rgba(245,158,11,0.2)', color: 'var(--color-amber)', border: '1px solid rgba(245,158,11,0.4)' }}>
          Review Payroll
        </button>
        <button onClick={() => setDismissed(true)} className="w-6 h-6 flex items-center justify-center rounded-md hover:bg-muted transition-colors">
          <Icon name="XMarkIcon" size={14} className="text-muted-foreground" />
        </button>
      </div>
    </div>
  );
}